import {axi, GetListOutput, GetListParams} from '@shared/api';
import {validateData} from '@shared/utils';
import {ReferralRecord} from '../types';
import {v8nSchemaOfGetReferralsResponse} from './backendSchemas';
import {GetReferralsResponse} from './backendTypes';
import {mapReferralRecordFromBackend} from './dataMappers';

export type GetReferralsParams = GetListParams;

export const getReferrals = async ({
  page,
  pageSize,
}: GetReferralsParams = {}): Promise<GetListOutput<ReferralRecord>> => {
  const response = await axi.get<GetReferralsResponse>('/admin/referrals', {
    params: {
      page,
      per_page: pageSize,
    },
  });

  validateData(response.data, v8nSchemaOfGetReferralsResponse, 'getReferrals');

  const {
    total,
    total_pages,
    array,
    page: pageFromBackend,
    per_page: pageSizeFromBackend,
  } = response.data;

  return {
    page: pageFromBackend,
    pageSize: pageSizeFromBackend,
    total,
    totalPages: total_pages,
    items: array.map(item => mapReferralRecordFromBackend(item)),
  };
};
